import React from "react";
import { FileDownload as Download } from "@mui/icons-material";
import styles from "./ResultCard.module.css";

function ResultCard({ title, url, index, onDownload }) {
  return (
    <div className={styles.card}>
      <p className={styles.title}>{title}</p>

      <div className={styles.body}>
        {url ? (
          <img
            src={url}
            alt={title}
            className={styles.img}
            draggable={false}
          />
        ) : (
          <div className={styles.loader}>
            <div className={`${styles.spinner} ${styles.spin}`} />
            <span className={styles.loaderText}>Loading…</span>
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <button
          type="button"
          onClick={() => url && onDownload(url, index)}
          disabled={!url}
          className={styles.downloadBtn}
        >
          <Download sx={{ fontSize: 14 }} />
          Download
        </button>
      </div>
    </div>
  );
}

export default React.memo(ResultCard);
